import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core'
import {StorageService} from '../../core/upload/upload.service'
import {LoaderService} from '../loader/loader.service'

@Component({
  selector: 'app-file-drag-drop',
  templateUrl: './file-drag-drop.component.html',
  styleUrls: ['./file-drag-drop.component.scss'],
})
export class FileDragDropComponent implements OnInit {
  showDropzones: boolean = false
  @Input() uploadpath: string
  @Input() user: any
  @ViewChild('dropzones') dropzones: ElementRef
  @Output() filesUploaded = new EventEmitter<any>()

  constructor(public storage: StorageService, public loader: LoaderService) {}

  ngOnInit() {
    let lastTarget = null
    window.addEventListener('dragenter', e => {
      lastTarget = e.target
      this.showDropzones = true
    })
    window.addEventListener('dragleave', e => {
      if (e.target === lastTarget) this.showDropzones = false
    })
  }

  onDrop(event, internal) {
    event.preventDefault()
    this.showDropzones = false
    const items = event.dataTransfer.items
    let entries = []
    const promises = []
    this.loader.start('Reading files...', 0)
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry()
      if (entry) {
        if (entry.isFile) {
          entries.push(entry)
        } else if (entry.isDirectory) {
          promises.push(
            FileDragDropComponent.traverseDirectory(entry).then(
              directoryEntries =>
                new Promise((resolve, reject) => {
                  entries.push(directoryEntries)
                  resolve()
                })
            )
          )
        }
      }
    }

    Promise.all(promises).then(result => {
      entries = this.flattenEntries(entries)
      this.entriesToFiles(entries).then(_files => {
        this.loader.start('Mapping files...', 0)
        let files = _files as Array<File>
        let map = this.storage.mapFiles(
          files,
          this.uploadpath,
          this.user,
          entries.map(entry => entry.fullPath.replace('/', ''))
        )
        this.storage.uploadFiles(map.files).then(() => {
          this.filesUploaded.emit(map.database)
        })
      })
    })
  }

  flattenEntries(entries) {
    function flatDeep(arr, d = 1) {
      return d > 0
        ? arr.reduce(
            (acc, val) =>
              acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val),
            []
          )
        : arr.slice()
    }

    return flatDeep(entries, Infinity)
  }

  entriesToFiles(entries) {
    const files = []

    return Promise.all(
      entries.map(
        entry =>
          new Promise((resolve, reject) => {
            entry.file(file => {
              resolve(file)
            })
          })
      )
    )
  }

  static traverseDirectory(entry) {
    const reader = entry.createReader()
    return new Promise((resolve, reject) => {
      const iterationAttempts = []
      function readEntries() {
        reader.readEntries(
          entries => {
            if (!entries.length) {
              resolve(Promise.all(iterationAttempts))
            } else {
              iterationAttempts.push(
                Promise.all(
                  entries.map(ientry => {
                    if (ientry.isFile) {
                      return ientry
                    }
                    return FileDragDropComponent.traverseDirectory(ientry)
                  })
                )
              )
              readEntries()
            }
          },
          error => reject(error)
        )
      }
      readEntries()
    })
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/file-drag-drop/file-drag-drop.component.ts